    <app-question-number [value]="activeQuestionId + 1"></app-question-number>

    <app-progress-bar [active]="activeQuestionId" [values]="progressBarData"></app-progress-bar>
    <div class="question-area">
      <h3 class="question" [innerHtml]="questionText"></h3>
    </div>

    <app-line></app-line>

    <div class="buttons" [ngClass]="{disabled: !showAnswers}">
      <app-button-goed (click)="selectAnswer('good');" [disabled]="!showAnswers && showAnswersGoodButton">{{audio.text.games.good}}</app-button-goed>
      <app-button-fout (click)="selectAnswer('wrong');" [disabled]="!showAnswers && showAnswersBadButton">{{audio.text.games.bad}}</app-button-fout>

      <!-- <div class="button green raised"
        [ngClass]="{'disabledSelected': !showAnswersGoodButton, 'disabled': (!showAnswers && showAnswersGoodButton)}"
        (click)="selectAnswer('good');">

      </div>
      <div class="button red raised"
        [ngClass]="{'disabledSelected': !showAnswersBadButton, 'disabled': (!showAnswers && showAnswersBadButton)}"
        (click)="selectAnswer('wrong');">

      </div> -->
    </div>
    <app-line></app-line>
    <!--									THE NEXT-WRAP ELEMENT NEEDS THE CLASS "INVISIBLE" WHEN NOT IN THE ANSWER SCREEN-->
    <div class="next-wrap">
      <div class="footnote" [ngClass]="{'invisible':!showFootnote}"><span>{{feedbackText}}</span></div>
      <app-button-next2 [disabled]="!showResults" (click)="setNextQuestion();
       audio.playSoundClick();">{{buttonCaption}}</app-button-next2>

    </div>

